const motionButton = document.querySelector('[data-mb-motion-toggle]');
if (motionButton) {
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const label = motionButton.querySelector('[data-mb-motion-label]');
  let paused = false;
  try { paused = localStorage.getItem('mb-motion-paused') === 'true'; } catch {}
  const update = () => {
    const off = paused || reduced.matches;
    root.dataset.mbMotion = off ? 'off' : 'on';
    motionButton.setAttribute('aria-pressed', String(!off));
    motionButton.disabled = reduced.matches;
    label.textContent = reduced.matches ? motionButton.dataset.reducedLabel : off ? motionButton.dataset.enableLabel : motionButton.dataset.pauseLabel;
    motionButton.dataset.ready = '';
  };
  motionButton.addEventListener('click', () => {
    paused = !paused;
    try { localStorage.setItem('mb-motion-paused', String(paused)); } catch {}
    update();
  });
  reduced.addEventListener('change', update);
  update();
}
